/*
 * Pure slash-command helpers for the feed composer.
 * Mirrors the conventions in mentions.js: no lookbehind regexes (iOS Safari),
 * module-level constants are never mutated.
 *
 * Slash commands are deliberately independent of @mentions — different sigil,
 * no precedence ordering between the two detectors.
 */

export const COMMANDS = [
    {
        id: 'fishCatch',
        aliases: ['fangst', 'catch'],
        icon: '🎣',
        textId: 'command.fish-catch',
        defaultText: 'Register catch',
    },
    {
        id: 'fishContact',
        aliases: ['kontakt', 'napp', 'contact'],
        icon: '🐟',
        textId: 'command.fish-contact',
        defaultText: 'Register contact',
    },
    {
        id: 'results',
        aliases: ['resultat', 'resultater', 'results'],
        icon: '🏆',
        textId: 'command.results',
        defaultText: 'Add results',
    },
    {
        id: 'map',
        aliases: ['kart', 'map'],
        icon: '📍',
        textId: 'command.map',
        defaultText: 'Add map',
    },
];

// Single token only. Commands never contain spaces — that rule is what keeps
// "kl 10 / 12" from opening the menu. Norwegian letters are allowed so /vær
// works later.
const QUERY_RE = /^[a-zA-ZæøåÆØÅ]{0,20}$/;

// Find an active "/query" immediately before the caret.
export function detectCommand(text, caretPos) {
    const before = String(text || '').slice(0, caretPos || 0);
    const slashIndex = before.lastIndexOf('/');
    if (slashIndex === -1) {
        return null;
    }
    if (slashIndex > 0 && !/\s/.test(before[slashIndex - 1])) {
        return null; // '/' glued to a word (URLs, dates, "Gaula/Orkla")
    }
    const query = before.slice(slashIndex + 1);
    if (!QUERY_RE.test(query)) {
        return null;
    }
    return { query, startIndex: slashIndex };
}

// Commands whose alias starts with the query. An empty query matches all.
// Always returns a NEW array — never hand out the COMMANDS constant.
export function matchCommands(query) {
    const q = String(query || '').toLowerCase();
    return COMMANDS.filter(command => command.aliases.some(alias => alias.startsWith(q)));
}

// Remove the active "/query" (from startIndex to caretPos) from the text.
export function removeCommand(text, startIndex, caretPos) {
    const source = String(text || '');
    const newText = source.slice(0, startIndex) + source.slice(caretPos);
    return { newText, newCaret: startIndex };
}
